import React from "react";

const ToAssign = () => {
  return (
    <div className="sales-tool-root">
      <h1>ToAssign comp</h1>
    </div>
  );
};

export default ToAssign;